import { registerPlugin } from '@capacitor/core';

export interface EnvConfigPlugin {
  getBuildVariant: () => Promise<{ flavor: string; buildType: string }>;
}

export const envConfig = registerPlugin<EnvConfigPlugin>('EnvConfig');
